const awsExports = {
  Auth: {
    userPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
    authenticationFlowType: process.env.REACT_APP_COGNITO_AUTH_FLOW,
    cookieStorage: {
      domain: window.location.href.includes('localhost') ? 'localhost' : '.alpha.co.uk',
      secure: !window.location.href.includes('localhost'),
      path: '/',
      expires: 0.5, // Expires after 12 hours Logic in cognito itself to configure expire time per env
    },
  },
};

export default awsExports;
